import React from 'react';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import SearchIcon from '@material-ui/icons/Search';
import HistoryIcon from '@material-ui/icons/History';
import { useLocalizedMessage } from '../../../../../util/useLocalizedMessage';
import styles from './IllustrativeContent.module.scss';

const PRODUCT_KEYS = ['cottonShirt', 'linenShirt', 'everydayTee', 'poloShirt', 'summerShirt', 'classicTee'];
const boundedCount = (value, fallback, max = 40) => Math.max(0, Math.min(max, Number.isFinite(Number(value)) ? Number(value) : fallback));

/** Clearly labeled sample content; no catalogue fetch or storefront interaction. */
export const SampleProducts = ({ maxItems, productsInRow, gap, cardType, theme, showImage, showPrice, showTitle, showRating, showAddToCart, showWishlist }) => {
  const t = useLocalizedMessage();
  const horizontal = cardType === 'horizontal';
  return (
    <div className={styles.products} style={{ gridTemplateColumns: `repeat(${Math.max(1, boundedCount(productsInRow, 4, 12))}, minmax(0, 1fr))`, gap }}>
      {Array.from({ length: boundedCount(maxItems, 12) }, (_, index) => (
        <div key={`sample-product-${index}`} className={`${styles.product} ${horizontal ? styles.horizontal : ''}`}>
          {showImage && (
            <div className={styles.image} style={{ color: theme?.palette?.primary?.main }}>
              <svg viewBox="0 0 120 120" role="img" aria-label={t(`searchInterface.preview.${PRODUCT_KEYS[index % PRODUCT_KEYS.length]}`)}>
                <path d="M38 20 18 31 8 55 29 65 35 51 35 103 85 103 85 51 91 65 112 55 102 31 82 20 72 28 48 28Z" fill="currentColor" opacity={0.3 + ((index % 3) * 0.15)} />
                <path d="M48 23Q60 45 72 23" fill="none" stroke="currentColor" strokeWidth="3" />
                {index % 2 === 1 && <path d="M59 36V101M42 53H78M42 70H78M42 87H78" fill="none" stroke="currentColor" strokeWidth="2" opacity=".35" />}
              </svg>
            </div>
          )}
          {cardType !== 'simple' && (
            <div className={styles.productInfo}>
              {showTitle && <span className={styles.productName}>{t(`searchInterface.preview.${PRODUCT_KEYS[index % PRODUCT_KEYS.length]}`)}</span>}
              {showPrice && <span className={styles.price}>{t('searchInterface.preview.samplePrice', { price: [29, 49, 19, 39, 35, 25][index % 6] })}</span>}
              {showRating && <span className={styles.rating}>★★★★☆</span>}
              {showAddToCart && <span className={styles.cart}><AddShoppingCartIcon fontSize="small" />{t('searchInterface.preview.addToCart')}</span>}
              {showWishlist && <FavoriteBorderIcon fontSize="small" />}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

const FACETS = [
  { key: 'category', values: ['shirts', 'tShirts', 'polos', 'knitwear', 'jackets', 'accessories'] },
  { key: 'size', values: ['XS', 'S', 'M', 'L', 'XL', 'XXL'], literal: true },
  { key: 'color', values: ['white', 'blue', 'green', 'black', 'beige', 'grey'] },
];
export const SampleFacets = ({ limitFacets, collapseKeepOpened, collapseIgnore = [] }) => {
  const t = useLocalizedMessage();
  return (
    <div>
      {FACETS.map((facet, index) => {
        const opened = index < Number(collapseKeepOpened) || collapseIgnore.includes(facet.key);
        const values = facet.values.slice(0, boundedCount(limitFacets, 5, facet.values.length));
        return (
          <div key={facet.key} className={styles.group}>
            <div className={styles.groupTitle}>{t(`searchInterface.preview.${facet.key}`)}<ExpandMoreIcon fontSize="small" /></div>
            {opened && values.map((value, valueIndex) => (
              <div className={styles.option} key={value}>
                <CheckBoxOutlineBlankIcon fontSize="small" />
                <span>{facet.literal ? value : t(`searchInterface.preview.${value}`)}</span>
                <span className={styles.count}>{24 - (valueIndex * 3)}</span>
              </div>
            ))}
            {opened && values.length < facet.values.length && <span>{t('searchInterface.preview.showMore')}</span>}
          </div>
        );
      })}
    </div>
  );
};

export const SampleSort = () => {
  const t = useLocalizedMessage();
  return <div className={styles.sort}><span>{t('searchInterface.preview.sampleResults')}</span><span className={styles.sortValue}>{t('searchInterface.preview.relevance')}<ExpandMoreIcon fontSize="small" /></span></div>;
};

export const SampleQueries = ({ kind, maxItems }) => {
  const t = useLocalizedMessage();
  const Icon = kind === 'history' ? HistoryIcon : SearchIcon;
  const keys = kind === 'catSuggestions' ? ['shirts', 'tShirts', 'polos', 'knitwear', 'jackets', 'accessories'] : PRODUCT_KEYS;
  return (
    <div className={styles.group}>
      <div className={styles.groupTitle}>{t(`searchInterface.preview.${kind}`)}</div>
      {Array.from({ length: boundedCount(maxItems, 5, 12) }, (_, index) => (
        <div className={styles.option} key={`query-${index}`}><Icon fontSize="small" /><span>{t(`searchInterface.preview.${keys[index % keys.length]}`)}</span></div>
      ))}
    </div>
  );
};
